<template>
  <li :class="$attrs.class" class="flex justify-between">
    {{ name }}
    <strong>
      {{ formatPrice(total) }}
    </strong>
  </li>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import formatPrice from '@/helpers/formatPrice';

defineProps({
  name: {
    type: String,
    required: true,
  },
  total: {
    type: [Number, String],
    required: true,
  },
});

</script>
